import { InfoOutlineIcon } from "@chakra-ui/icons";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";

import { useColor } from "@/styles/useColor";

interface MinimumReceivedDisplayProps {
  minimumReceived: string;
  buyTokenSymbol: string;
}

export const MinimumReceivedDisplay = ({
  minimumReceived,
  buyTokenSymbol,
}: MinimumReceivedDisplayProps) => {
  const color = useColor();

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center" gap="2">
        <Text color={color("500")} fontWeight="600">
          Receive at least
        </Text>
        <Tooltip
          label={
            "If the price drops beyond this point, your transaction won't go through. The minimum amount you're guaranteed to receive is shown below. Minimum guaranteed: " +
            minimumReceived +
            " " +
            buyTokenSymbol
          }
        >
          <Box as="span">
            <InfoOutlineIcon width="16px" height="16px" color={color("500")} />
          </Box>
        </Tooltip>
      </Flex>
      <Text color={color("700")}>
        {minimumReceived} {buyTokenSymbol}
      </Text>
    </Flex>
  );
};
